(function () {
  const DELIVERY_SELECTOR = '.delivery-widget__auto';
  const TOLSTOY_SELECTOR = '.tolstoy-stories';

  let deliveryEl = null;
  let tolstoyEl = null;

  function tryMove() {
    // If both exist, move Tolstoy and stop observing
    if (deliveryEl && tolstoyEl) {
      // Only move if it's not already in the right place
      if (deliveryEl.nextElementSibling !== tolstoyEl) {
        deliveryEl.insertAdjacentElement('afterend', tolstoyEl);
        console.log('Tolstoy moved after delivery-widget__auto', tolstoyEl);
      }
      observer.disconnect();
    }
  }

  function check() {
    if (!deliveryEl) {
      const d = document.querySelector(DELIVERY_SELECTOR);
      if (d) {
        console.log('delivery-widget__auto found', d);
        deliveryEl = d;
      }
    }

    if (!tolstoyEl) {
      const t = document.querySelector(TOLSTOY_SELECTOR);
      if (t) {
        console.log('tolstoy-stories found', t);
        tolstoyEl = t;
      }
    }

    tryMove();
  }

  // Initial check
  check();

  const observer = new MutationObserver(check);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
